import React, { useEffect } from 'react';
import { Link } from 'react-scroll';
import { 
  BiHome, BiUser, BiFile, BiImages, BiServer, BiEnvelope, BiMenu, BiX 
} from 'react-icons/bi';
import { 
  FaGithub, FaLinkedin, FaWhatsapp 
} from 'react-icons/fa';
import profileImg from '../assets/img/Profile2.jpg';

const Header = ({ mobileNavActive, setMobileNavActive }) => {
  
  const toggleMenu = () => {
    setMobileNavActive(!mobileNavActive);
  };

  const closeMenu = () => {
    if (window.innerWidth <= 1199) {
      setMobileNavActive(false);
    }
  };

  // Prevent background scrolling when mobile menu is open
  useEffect(() => {
    if (mobileNavActive && window.innerWidth <= 1199) {
      document.body.classList.add('mobile-nav-open');
    } else {
      document.body.classList.remove('mobile-nav-open');
    }
    return () => {
      document.body.classList.remove('mobile-nav-open');
    };
  }, [mobileNavActive]);

  return (
    <>
      {/* Floating Toggle Button (Visible always) */}
      <button 
        type="button"
        aria-label={mobileNavActive ? 'Close navigation menu' : 'Open navigation menu'}
        className="header-toggle d-flex align-items-center justify-content-center" 
        onClick={toggleMenu}
      >
        {mobileNavActive ? <BiX /> : <BiMenu />}
      </button>

      {/* Mobile Backdrop Overlay - closes menu when clicking outside */}
      {mobileNavActive && (
        <div 
          className="mobile-nav-backdrop" 
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}

      <header id="header" className={`header ${mobileNavActive ? 'header-active' : ''}`}>
        <div className="profile-img">
          <img src={profileImg} alt="Muhammad Jahanzaib Iqbal" />
        </div>

        <Link to="hero" className="logo d-flex align-items-center justify-content-center" onClick={closeMenu}>
          <h1 className="sitename">Muhammad Jahanzaib</h1>
        </Link>

        <div className="social-links text-center">
          <a href="https://github.com/MuhammadJahanzaibIqbal" target="_blank" rel="noreferrer" aria-label="GitHub"><FaGithub /></a>
          <a href="https://www.linkedin.com/in/muhammad-jahanzaib-iqbal-64a994292/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
          <a href="https://wa.me/923021164516" target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
        </div>

        <nav id="navmenu" className="navmenu">
          <ul>
            {[
              { to: 'hero', icon: <BiHome />, label: 'Home' },
              { to: 'about', icon: <BiUser />, label: 'About' },
              { to: 'skills', icon: <BiFile />, label: 'Skills' },
              { to: 'resume', icon: <BiFile />, label: 'Resume' },
              { to: 'portfolio', icon: <BiImages />, label: 'Portfolio' },
              { to: 'services', icon: <BiServer />, label: 'Services' },
              { to: 'contact', icon: <BiEnvelope />, label: 'Contact' }
            ].map((item, index) => (
              <li key={index}>
                <Link 
                  to={item.to} 
                  spy={true} 
                  smooth={true} 
                  offset={-80} 
                  duration={500} 
                  activeClass="active"
                  onClick={closeMenu}
                >
                  {item.icon} {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;
